import React, { useContext, useEffect, useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  KeyboardAvoidingView,
} from "react-native";
import { Avatar } from "react-native-elements";
import { useNavigation } from "@react-navigation/native";

import { ContainerButton, TextTitlePage } from "./styles";
import {
  Header,
  Container,
  Content,
  TextField,
  Button,
  CustomDropDown,
} from "../../../components";
import UserContext from "../../../context/user";
import RegisterDriverContext from "../../../context/registerDriver";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";

function AddDriverAdmin({ route }) {
  const navigation = useNavigation();
  const { drivers, registerDrivers, getDrivers, updateDataDriver } = useContext(
    RegisterDriverContext
  );
  const [typeUserOpen, setTypeUserOpen] = useState(false);
  const [typeUserValue, setTypeUserValue] = useState(0);
  const [activeDriverOpen, setActiveDriverOpen] = useState(false);
  const [activeDriverValue, setActiveDriverValue] = useState("0");

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (route.params.edit) {
      const filteredDrivers = drivers.filter(
        (element: any) => element.id === route.params.id
      );
      console.log(filteredDrivers[0].active);
      setName(filteredDrivers[0].name ?? "");
      setPhone(filteredDrivers[0].phone ?? "");
      setEmail(filteredDrivers[0].email ?? "");
      setTypeUserValue(filteredDrivers[0].role_id.toString());
      setActiveDriverValue(filteredDrivers[0].active.toString() ?? "0");
    }
  }, []);

  async function handleRegister() {
    setLoading(true);
    try {
      const data = { name, phone, email, role_id: typeUserValue };
      const dataEdit = {
        name,
        phone,
        email,
        role_id: typeUserValue,
        active: parseInt(activeDriverValue),
        is_client: 0,
      };
      if (route.params.edit) {
        await updateDataDriver(dataEdit, route.params.id);
      } else {
        await registerDrivers(data);
      }
      // await getDrivers();
      setLoading(false);
      navigation.navigate("ReportAdmin");
    } catch (_) {
      console.log("error registerDrivers screen");
      setLoading(false);
    }
  }

  return (
    <Container>
      <Header
        type="simple"
        title={route.params.edit ? "Editar motorista" : "Adicionar motorista"}
      />
      <Content>
          <TextTitlePage>
            {route.params.edit
              ? "Editar novo motorista"
              : "Adicionar novo motorista"}
          </TextTitlePage>
          <View>
            <TextField
              label="Nome"
              placeholder="Digite seu nome"
              value={name}
              onChangeText={(text: string) => setName(text)}
            />
          </View>
          <View>
            <TextField
              label="Telefone"
              placeholder="Digite seu telefone"
              value={phone}
              mask="cel-phone"
              onChangeText={(text: string) => setPhone(text)}
            />
          </View>
          <View>
            <TextField
              label="E-mail"
              placeholder="Digite seu e-mail"
              value={email}
              keyboardType="email-address"
              onChangeText={(text: string) => setEmail(text)}
            />
          </View>

          <View style={{ position: "relative", zIndex: 3 }}>
            <CustomDropDown
              open={typeUserOpen}
              value={typeUserValue}
              items={[
                { label: "Administrador", value: "1" },
                { label: "Motorista", value: "2" },
              ]}
              setOpen={setTypeUserOpen}
              setValue={setTypeUserValue}
              placeholder="Tipo de acesso"
              setItems={setTypeUserValue}
            />
          </View>
          {route.params.edit && (
            <CustomDropDown
              open={activeDriverOpen}
              value={activeDriverValue}
              items={[
                { label: "Ativo", value: "1" },
                { label: "Desativado", value: "0" },
              ]}
              setOpen={setActiveDriverOpen}
              setValue={setActiveDriverValue}
              placeholder="Ativo"
              setItems={setActiveDriverValue}
            />
          )}
        <ContainerButton>
          <Button
            title={route.params.edit ? "Atualizar" : "Cadastrar"}
            loading={loading}
            onPress={handleRegister}
          />
        </ContainerButton>
      </Content>
    </Container>
  );
}

export default AddDriverAdmin;
